import { useDateFnsWithLocale } from 'hooks/i18n';
import useKeycloak from 'hooks/useKeycloak';
import getErrorI18nConfig from 'i18n/errorConfig';
import { useSession } from 'next-auth/react';
import NProgress from 'nprogress';
import { useEffect } from 'react';
import { isInAppWebview, onStopProgress } from 'utils/webview';
import { setLocale } from 'yup';

export const usePageSetup = (isSecurePage: boolean) => {
  const session = useSession();
  const { keycloakSignin } = useKeycloak();
  const { format } = useDateFnsWithLocale();

  setLocale(getErrorI18nConfig(format));

  useEffect(() => {
    if ((isSecurePage && session.data === null) || session.data?.error === 'RefreshAccessTokenError') {
      keycloakSignin();
    }
  }, [session, keycloakSignin, isSecurePage]);

  useEffect(() => {
    if (isInAppWebview()) {
      onStopProgress(() => {
        NProgress.done();
      });
    }
  }, []);

  return {
    session,
    format,
  };
};
